module.exports = __webpack_public_path__ + "assets/flash-card-demo-b444261a94b901adbe384df76e4b1dae.webm";